import { AxiosError } from "axios";

export default function isAxiosError(obj: any): obj is AxiosError {
  return obj.isAxiosError
}
